// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FolderOpenFilledSvg from "@fishx/icons-svg/es/asn/FolderOpenFilled";
import FishxIcon from '../components/FishxIcon';

var FolderOpenFilled = function FolderOpenFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FolderOpenFilledSvg
  }));
};

FolderOpenFilled.displayName = 'FolderOpenFilled';
export default React.forwardRef(FolderOpenFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FolderOpenFilled.js
// module id = 2799
// module chunks = 0